<template>
  <div class="edit-profile-form">
    <v-row>
        <v-col cols="0" sm="2" class="d-none d-sm-block" />
        <v-col cols="12" sm="8">
            <div ref="formArea" class="edit-profile-form__area" :style="{height: areaHeight + 'px'}">
                <v-form ref="formProfile" class="edit-profile-form__form pb-4 text-center">
                    <div class="edit-profile-form__fixed">
                        <strong class="v-size--large"> {{ trainer.fullTitle }} </strong>
                    <v-text-field
                        color="black"
                        class="black--text"
                        v-model="name"
                        outlined
                        :loading="isLoading"
                        :rules="nameRules"
                        :label="$t('user.editProfileForm.nameFieldLabel')"
                        dense
                    />
                    </div>
                    <!-- swiper-no-swiping je Swiper.js konvence (noSwipingClass) - bez ni by tazeni po avataru zaroven prepinalo tab v outer TrainerBag swiperu -->
                    <div class="swiper-no-swiping edit-profile-form__carousel-wrap">
                        <v-carousel
                            v-model="imgId"
                            height="100%"
                            hide-delimiters
                            tile
                        >
                            <v-carousel-item
                                v-for="pic in images"
                                :key="pic"
                            >
                                <v-sheet
                                    class="transparent"
                                    height="100%"
                                >
                                    <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="center"
                                    >
                                        <v-img
                                            :src="require(`@/assets/pic/trainer/`+pic)"
                                            height="100%"
                                            class="ma-0 pa-0 fill-height"
                                            contain
                                        />
                                    </v-row>
                                </v-sheet>
                            </v-carousel-item>
                        </v-carousel>
                    </div>
                    <v-btn
                        v-if="name.length > 2  && name.length < 17 "
                        class="skin-btn-save edit-profile-form__fixed"
                        :loading="isLoading"
                        @click="edit()"
                    >
                        {{ $t('user.editProfileForm.saveButton') }}
                    </v-btn>
                </v-form>
                <v-row v-if="oakMessage !== null" class="edit-profile-form__fixed">
                    <OakHelp
                        v-model="oakMessage"
                        class="font-weight-bold"
                        :class="{'red--text': this.error, 'green--text': !this.error}"
                    />
                </v-row>
                <div ref="footerEnd" class="text-center edit-profile-form__fixed">
                    <v-btn
                        class="skin-btn-editprofile mt-6"
                        @click="showChangePassword = true"
                    >
                        {{ $t('user.editProfileForm.changePasswordButton') }}
                    </v-btn>
                </div>
            </div>
        </v-col>
        <v-col cols="0" sm="2" class="d-none d-sm-block" />
    </v-row>

    <ResponsiveDialog v-model="showChangePassword" :max-width="480" color="warning" header-class="skin-window-header--editprofile" :full-height="false" header-icon="🔒" :header-title="$t('user.editProfileForm.changePasswordDialogTitle')" card-class="skin-card">
            <v-card-text class="justify-center text-center fab-clearance skin-window--editprofile">
                <v-form ref="formPasswd" class="editprofile-adaptive-text" lazy-validation>
                    <v-text-field
                        v-model="pswdOld"
                        color="black"
                        type="password"
                        class="black--text"
                        outlined
                        :loading="isLoading"
                        :rules="pswdOldRules"
                        :label="$t('user.editProfileForm.currentPasswordLabel')"
                        dense
                    />
                    <v-text-field
                        v-model="pswd"
                        color="black"
                        type="password"
                        class="black--text"
                        :loading="isLoading"
                        :rules="pswdRules"
                        outlined
                        :label="$t('user.editProfileForm.newPasswordLabel')"
                        dense
                    />
                    <v-text-field
                        v-model="pswd2"
                        color="black"
                        type="password"
                        class="black--text"
                        outlined
                        :loading="isLoading"
                        :rules="pswd2Rules"
                        :label="$t('user.editProfileForm.passwordRepeatLabel')"
                        dense
                    />
                    <v-btn
                        @click="submitPasswd()"
                        :loading="isLoading"
                        class="skin-btn-editprofile"
                    >{{ $t('user.editProfileForm.changePasswordButton') }}</v-btn>
                </v-form>
                <v-row v-if="oakMessage !== null">
                    <OakHelp
                        v-model="oakMessage"
                        class="font-weight-bold"
                        :class="{'red--text': this.error, 'green--text': !this.error}"
                    />
                </v-row>
            </v-card-text>

            <v-card-actions class="d-none d-md-flex">
                <v-spacer></v-spacer>
                <v-btn
                    class="skin-btn-editprofile"
                    @click="showChangePassword = false"
                >
                    {{ $t('user.editProfileForm.closeButton') }}
                </v-btn>
            </v-card-actions>
    </ResponsiveDialog>
  </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {API_ENTRYPOINT} from "@/config/entrypoint";
    import OakHelp from "@/components/utils/OakHelp";
    import ResponsiveDialog from "@/components/utils/ResponsiveDialog";

    export default {
        components: {OakHelp, ResponsiveDialog},
        props: {
            trainer: {type: Object, required: true},
            // true kdyz je "Edit Profile" prave aktivni tab - vsech 5 oken v outer swiperu je smontovanych naraz, takze prvni vypocet v mounted() muze bezet driv, nez ma tenhle tab realnou pozici
            active: {type: Boolean, default: false},
        },
        data() {
            return {
                showChangePassword: false,
                name: '',
                pswdOld: '',
                pswd: '',
                pswd2: '',
                img: '',
                imgId: 0,
                images: '',
                oakMessage: null,
                areaHeight: 500,
            }
        },
        watch: {
            imgId(){
                this.img = this.images[this.imgId];
            },
            active(isActive){
                if (isActive) {
                    this.$nextTick(this.updateAreaHeight);
                }
            },
        },
        computed: {
            ...mapGetters({
                user: 'user/item',
                userId: 'user/userId',
                isLoading: 'user/isLoading',
                error: 'user/error',
            }),
            // musi byt computed, ne data() - $t() uvnitr potrebuje reagovat na zmenu jazyka (viz i18n-conventions.md bod 8)
            nameRules() {
                return [
                    v => !!v || this.$t('user.editProfileForm.nameRequired'),
                    v => (v && v.length <= 16) || this.$t('user.editProfileForm.nameMaxLength'),
                    v => (v && v.length > 2) || this.$t('user.editProfileForm.nameMinLength'),
                ];
            },
            pswdOldRules() {
                return [
                    v => !!v || this.$t('user.editProfileForm.oldPasswordRequired'),
                    v => (v && v.length <= 31) || this.$t('user.editProfileForm.passwordMaxLength'),
                    v => (v && v.length >= 4) || this.$t('user.editProfileForm.passwordMinLength'),
                ];
            },
            pswdRules() {
                return [
                    // Puvodni hlaska "Old password is required" pro NOVE heslo je pre-existujici bug (spatna hlaska
                    // pro toto pole) - HYB fidelita ho zachovava beze zmeny chovani, jen presouva text do i18n.
                    v => !!v || this.$t('user.editProfileForm.oldPasswordRequired'),
                    v => (v && v.length <= 31) || this.$t('user.editProfileForm.passwordMaxLength'),
                    v => (v && v.length >= 4) || this.$t('user.editProfileForm.passwordMinLength'),
                ];
            },
            pswd2Rules() {
                return [
                    v => !!v || this.$t('user.editProfileForm.oldPasswordRequired'),
                    v => (v && v.length <= 31) || this.$t('user.editProfileForm.passwordMaxLength'),
                    v => (v && v.length >= 4) || this.$t('user.editProfileForm.passwordMinLength'),
                    v => (v && v === this.pswd) || this.$t('user.editProfileForm.passwordsMustMatch'),
                ];
            },
        },
        created() {
            const filesObj = require.context(
                '@/assets/pic/trainer/players',
                true,
                /^.*\.png$/
            );
            let files = filesObj.keys();
            files = files.map(function(item) {
                let string = 'players'+item;
                string = string.replace('players.','players');
                return string;
            });
            this.images = files;
            this.imgId = files.indexOf(this.trainer.img);
            this.name = this.user.name;
        },
        mounted() {
            this.$nextTick(this.updateAreaHeight);
            window.addEventListener('resize', this.updateAreaHeight);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateAreaHeight);
        },
        methods: {
            ...mapActions({
                fetchObject: 'user/fetchObject',
                editUser: 'user/editUser',
                resetError: 'user/resetError',
            }),
            // "top" formArea je urcen jen tim, co je NAD nim (tab pilulky), nezavisi na obsahu tabu - jednorazovy vypocet staci, zadny iterativni dopocet neni potreba
            updateAreaHeight() {
                const areaEl = this.$refs.formArea;
                const scrollContainer = this.$el.closest('.trainer-detail-page__scroll');
                if (!areaEl || !scrollContainer) {
                    return;
                }
                const top = areaEl.getBoundingClientRect().top;
                const visibleBottom = scrollContainer.getBoundingClientRect().bottom;
                const next = Math.max(320, Math.floor(visibleBottom - top - 4));
                if (next === this.areaHeight) {
                    return;
                }
                this.areaHeight = next;
                // outer tab-swiper (TrainerBag.vue) prepocitava autoHeight jen pri zmene slidu/resize, ne pri zmene DOM uvnitr aktualniho slidu
                this.$nextTick(() => this.$emit('layout-changed'));
            },
            submitPasswd(){
                let canChangePassword = this.$refs.formPasswd.validate();
                this.resetError();
                if (canChangePassword){
                    const url = new URL("api/change-password", API_ENTRYPOINT);
                    const obj = {url: url, obj:{account: parseInt(this.userId), oldPassword: this.pswdOld, newPassword: this.pswd},method:'PATCH'}
                    this.fetchObject(obj).then(
                        () => {
                            this.oakMessage = this.$t('user.editProfileForm.changePasswordSuccess');
                            this.pswdOld = this.pswd;
                        }
                    ).catch(() => {
                        this.oakMessage = this.error || this.$t('user.editProfileForm.changePasswordFailed');
                    });
                }
            },
            edit(){
                this.resetError();
                this.oakMessage = null;
                let canEditProfile = this.$refs.formProfile.validate();
                if (canEditProfile){
                    const url = new URL("api/trainers/"+this.user.id, API_ENTRYPOINT);
                    const obj = {url: url, obj:{name: this.name, npc:false, img: this.img},method:'PATCH'}
                    this.fetchObject(obj).then(
                        (data) => {
                            this.editUser(data);
                            this.oakMessage = null;
                        }
                    ).catch(() => {
                        this.oakMessage = (this.error && this.error.includes('Not Found'))
                            ? this.$t('user.editProfileForm.profileNotFound')
                            : (this.error || this.$t('user.editProfileForm.editProfileFailed'));
                    });
                }
            },
        },

    }
</script>

<style scoped>
    /* .edit-profile-form__area dostane zmerenou vysku (updateAreaHeight() ve skriptu), carousel (flex:1) sezere zbytek - panacek tak vyplni cely dostupny prostor */
    .edit-profile-form__area {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .edit-profile-form__form {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
    }
    .edit-profile-form__fixed {
        flex: 0 0 auto;
    }
    .edit-profile-form__carousel-wrap {
        flex: 1 1 auto;
        min-height: 0;
    }
    /* v-btn je flex-item (ne inline-block) - vychozi align-items:stretch ho roztahne na celou sirku sloupce bez tohohle */
    .skin-btn-save {
        align-self: center;
    }

    /* pozadi popupu ridi skin (.skin-window--editprofile), tady jen theme-adaptivni text */
    .theme--light .editprofile-adaptive-text {
        color: rgba(0, 0, 0, .87);
    }
    .theme--dark .editprofile-adaptive-text {
        color: rgba(255, 255, 255, .87);
    }
    .fab-clearance {
        /* Change Password popup ma ResponsiveDialog zaviraci krizek na mobilu, viz TrainerDetail.vue */
        padding-bottom: var(--responsive-dialog-close-clearance) !important;
    }

    @media (min-width: 960px) {
        .fab-clearance {
            padding-bottom: 16px !important;
        }
    }
</style>
